export default {
    init() {
        if ($(".module-roulette-statistique")[0]) {
            $(".module-roulette-statistique").each(function() {
                var roulette = $(this);

                var rouletteLength = roulette.find(".slides-holder__item").length;

                // Définition des variables pour garder une trace de l'item affiché et les items adjacents
                var active_item = 0;

                var left_item = rouletteLength - 1;
                var old_left_item = rouletteLength - 2;

                var right_item = 1;
                var old_right_item = 0;

                $($(".roulette-text")[active_item]).css("display", "block");

                if (rouletteLength >= 3) {
                    $($(".slides-holder__item ")[left_item]).addClass("left_slide");
                }
                if (rouletteLength >= 2) {
                    $($(".slides-holder__item ")[right_item]).addClass("right_slide");
                }
                $($(".slides-holder__item ")[active_item]).addClass("slides-holder__item_active");

                // Initialisation de la taille du slider, de ses items et du temps de l'animation
                function startSetup(sliderSize, slideSize, animationDuration) {

                    this.sliderSize = parseFloat(sliderSize) / 100;
                    this.slideSize = parseFloat(slideSize) / 100;
                    this.animationDuration = parseFloat(animationDuration);
                };

                // Constructeur pour le slider
                function Slider(newSlider, sliderSize, slideSize, animationDuration) {

                    this.startSetup = new startSetup(sliderSize, slideSize, animationDuration);

                    // Récupération des éléments dans le slider
                    this.wrapper = newSlider.querySelector('.wrapper');
                    this.slides = newSlider.querySelectorAll('.circular-slider .wrapper .slides-holder .slides-holder__item');
                    this.slidesHolder = newSlider.querySelector('.circular-slider .wrapper .slides-holder');
                    this.btnLeft = newSlider.querySelector('.left_slide');
                    this.btnRight = newSlider.querySelector('.right_slide');


                    // Définition de l'angle de rotation pour le slider
                    this.slidesSize = 0;
                    this.currentAngle = 0;
                    this.stepAngle = 2 * Math.PI / newSlider.querySelectorAll('.circular-slider .wrapper .slides-holder .slides-holder__item').length;
                    this.currentSlide = 0;
                    this.slidesHolder.style.transitionDuration = this.startSetup.animationDuration + 'ms';

                    // Fonctions pour initialiser le style et la position des items du slider
                    this.onResize();
                    this.setNav();
                    this.addStyle();

                    const self = this
                    $(window).on('resize', function () {
                        self.onResize()
                    })

                    if (self.btnLeft) {
                        /* let interval = setInterval(function () {
                            goToNextItem(self)
                        }, 3000) */

                        $('.roulette-nav-prev').on('click', function() {
                            //clearInterval(interval)
                            goToPrevItem(self)
                        })

                        $('.roulette-nav-next').on('click', function() {
                            //clearInterval(interval)
                            goToNextItem(self)
                        })
                    }
                };




                // Corrige le positionnement du slider et de ses items lorsque la page est redimensionnée
                Slider.prototype.onResize = function() {

                    let radius,
                        w = this.wrapper.parentNode.getBoundingClientRect().width,
                        h = this.wrapper.parentNode.getBoundingClientRect().height;

                    2 * h <= w ? radius = h * this.startSetup.sliderSize :
                        radius = (w / 2) * this.startSetup.sliderSize;

                    this.setPosition(Math.round(radius));
                };

                // Initialise la taille et le positionnement des items du slider
                Slider.prototype.setPosition = function(radius) {
                    let r = 2 * radius * (1 - this.startSetup.slideSize);
                    this.slidesRepositioning(r / 2);

                    this.slidesHolder.style.marginTop = r / 2;

                    this.slidesSize = Math.min(2 * radius * this.startSetup.slideSize, this.stepAngle * radius * (1 - this.startSetup.slideSize) - 50);
                };

                // Change le positionnement des items du slider
                Slider.prototype.slidesRepositioning = function(r) {
                    for (let i = 0; i < this.slides.length; i++) {
                        let x = r * Math.cos(this.stepAngle * i - Math.PI / 2),
                            y = r * Math.sin(this.stepAngle * i - Math.PI / 2);
                        const additionalRotate = window.matchMedia('(max-width: 767px)').matches ? 0 : 90

                        this.slides[i].style.transform = 'translate( ' + x + 'px, ' + y + 'px ) rotate( ' + (this.stepAngle * 180 / Math.PI * i + additionalRotate) + 'deg )';
                    };

                };

                // Fonction permettant d'effectuer la rotation des items dans le slider
                Slider.prototype.rotate = function(multiplier) {
                    let _this = this;

                    this.removeStyle();
                    this.resetNavs();

                    if (this.currentSlide === this.slides.length - 1 && multiplier === -1) {
                        this.slidesHolder.style.transform = 'rotate( -360deg )';
                        this.currentSlide = this.currentAngle = 0;
                        this.addStyle();

                        setTimeout(function() {

                            _this.slidesHolder.style.transitionDuration = 0 + 's';
                            _this.slidesHolder.style.transform = 'rotate( ' + _this.currentAngle + 'deg )';
                            setTimeout(function() { _this.slidesHolder.style.transitionDuration = _this.startSetup.animationDuration + 'ms'; }, 20);

                        }, this.startSetup.animationDuration);

                    } else if (this.currentSlide === 0 && multiplier === 1) {
                        this.slidesHolder.style.transform = 'rotate( ' + this.stepAngle * 180 / Math.PI + 'deg )';
                        this.currentSlide = _this.slides.length - 1;
                        this.currentAngle = -(2 * Math.PI - _this.stepAngle) * 180 / Math.PI;
                        this.addStyle();

                        setTimeout(function() {

                            _this.slidesHolder.style.transitionDuration = 0 + 's';
                            _this.slidesHolder.style.transform = 'rotate( ' + _this.currentAngle + 'deg )';
                            setTimeout(function() { _this.slidesHolder.style.transitionDuration = _this.startSetup.animationDuration + 'ms'; }, 20);

                        }, this.startSetup.animationDuration);

                    } else {

                        this.currentSlide -= multiplier;
                        this.currentAngle += (this.stepAngle * 180 / Math.PI) * multiplier;
                        this.slidesHolder.style.transform = 'rotate( ' + this.currentAngle + 'deg )';

                        this.addStyle();

                    };
                    this.btnLeft = $('.left_slide')[0];

                    this.btnRight = $('.right_slide')[0];

                    $(".roulette-text").css("display", "none");
                    $($(".roulette-text")[active_item]).css("display", "block");

                };

                // Fonction permettant de modifier l'index de l'item affiché
                function get_next_item(current) {
                    var active_item = current;

                    if (current < 0) {
                        active_item = rouletteLength - 1;
                    } else if (current > rouletteLength - 1) {
                        active_item = 0;
                    }
                    return active_item;
                }

                function goToNextItem (currentSlider) {
                        old_left_item = left_item;

                        active_item--;
                        active_item = get_next_item(active_item);

                        left_item = active_item - 1;
                        left_item = get_next_item(left_item);

                        old_right_item = right_item;

                        right_item = active_item + 1;
                        right_item = get_next_item(right_item);

                        currentSlider.rotate(1);
                }

                function goToPrevItem (currentSlider) {
                    old_left_item = left_item;

                    active_item++;
                    active_item = get_next_item(active_item);

                    left_item = active_item - 1;
                    left_item = get_next_item(left_item);

                    old_right_item = right_item;

                    right_item = active_item + 1;
                    right_item = get_next_item(right_item);


                    currentSlider.rotate(-1);
                }


                Slider.prototype.resetNavs = function() {
                    let _this = this;

                    this.disableNav();
                    setTimeout(function() { _this.setNav() }, this.startSetup.animationDuration + 20);
                };

                // Lorsqu'un item adjacent est cliqué, change les index des items et tourne le slider
                Slider.prototype.setNav = function() {

                    let _this = this;

                    if (_this.btnLeft) {
                        // Lorsque l'on clique sur l'item adjacent à gauche
                        _this.btnLeft.onclick = function() {
                            goToNextItem(_this)
                        }
                    }

                    if (_this.btnRight) {
                        // Lorsque l'on clique sur l'item adjacent à droite
                        _this.btnRight.onclick = function() {
                            goToPrevItem(_this)
                        };
                    }


                };

                Slider.prototype.removeStyle = function() {

                    let x = this.currentSlide;

                    this.slides[x].classList.remove('slides-holder__item_active');

                    this.slides[old_left_item].classList.remove('left_slide');

                    this.slides[old_right_item].classList.remove('right_slide');

                };

                // Fonction qui agrandit l'item mis en avant et affiche l'image
                Slider.prototype.addStyle = function() {

                    let x = this.currentSlide;

                    this.slides[x].classList.add('slides-holder__item_active');

                    if (rouletteLength >= 3) {
                        this.slides[left_item].classList.add('left_slide');
                    }
                    if (rouletteLength >= 2) {
                        this.slides[right_item].classList.add('right_slide');
                    }

                    roulette.find('.slides-holder__item').each(function(index, obj) {
                        if ($(obj).hasClass("slides-holder__item_active")) {
                            $(obj).children("img").addClass('reveal_anim');

                        } else {
                            $(obj).children("img").removeClass('reveal_anim');
                        }

                    });
                };

                Slider.prototype.disableNav = function() {
                    this.btnLeft.onclick = null;
                    this.btnRight.onclick = null;
                };

                window.circularSlider = new Slider(document.querySelector('.circular-slider'), 100, 15, 600, 2500);
            })
        }

    },
};